import { Container } from 'inversify-props';
import setupKuspit from './kuspit/setup';
import setupAllianz from './allianz/setup';

export default function setupCatalogs(container: Container) {
  setupKuspit(container);
  setupAllianz(container);
}
